import axios from 'axios';

const updatePinForDirectKey = async (body: {
  currentPin: string;
  newPin: string;
  userId: string;
  orgId: string;
}) => {
  const {
    data: { error: response },
  } = await axios.post<{ error?: string }>(`/direct_key_pin/update`, body);

  return response;
};

export default updatePinForDirectKey;
